module.exports = __webpack_public_path__ + "img/agree-checked@3x.ca844d48.png";